// extracted by mini-css-extract-plugin
module.exports = {"logo":"FancyPromo--logo--1mB7v"};